// Português (Brasil) — mirrors the key structure of en.js exactly.
const ptBR = {
  common: {
    backToHome: 'Voltar para o início',
    studentAlt: 'Aluno {{index}}',
  },
  nav: {
    home: 'Início',
    courses: 'Cursos',
    pricing: 'Preços',
    about: 'Sobre',
    contact: 'Contato',
    faq: 'Perguntas Frequentes',
    levelTest: 'Teste de Nível',
    bookTrial: 'Agendar Aula',
  },
  home: {
    badges: {
      globalExpertise: 'EXPERIÊNCIA GLOBAL',
      cambridgeCertified: 'CERTIFICAÇÃO CAMBRIDGE',
      academicExcellence: 'EXCELÊNCIA ACADÊMICA',
      nativeSpeakerInsight: 'VISÃO NATIVA',
      resultsDriven: 'FOCO EM RESULTADOS',
    },
    trust: {
      businessName: 'Inglês para Negócios', businessLine1: 'Inglês para', businessLine2: 'Negócios',
      generalName: 'Inglês Geral', generalLine1: 'Inglês', generalLine2: 'Geral',
      speakingName: 'Desenvolvimento da Fala', speakingLine1: 'Desenvolvimento', speakingLine2: 'da Fala',
      academicName: 'Redação Acadêmica', academicLine1: 'Redação', academicLine2: 'Acadêmica',
      portugueseName: 'Português para Estrangeiros', portugueseLine1: 'Português para', portugueseLine2: 'Estrangeiros',
      oneToOneName: 'Aula Individual', oneToOneLine1: 'Aula', oneToOneLine2: 'Individual',
    },
    video: {
      playVideo: 'Reproduzir vídeo',
      replayVideo: 'Assistir novamente',
      replay: 'Assistir de novo',
      mute: 'Sem som',
      unmute: 'Ativar som',
      volume: 'Volume',
      liveLessons: 'Aulas ao vivo disponíveis agora',
    },
    heroImageAlt: 'Cida, professora de inglês, recebendo os alunos',
    carousel: {
      previous: 'Anterior',
      next: 'Próximo',
      navigation: 'Navegação do carrossel',
      show: 'Mostrar {{title}}',
    },
    community: {
      multiculturalStudents: 'Alunos multiculturais',
      aviationLesson: 'Aula de inglês para aviação',
      readingStrategiesLesson: 'Aula de estratégias avançadas de leitura',
      badge: 'Comunidade Global',
      title: 'Junte-se a Alunos de [hl]Todo o Mundo[/hl]',
      body: 'Nossos alunos vêm de diferentes origens e culturas, unidos pelo objetivo de se comunicar em inglês com confiança. Você fará parte de uma comunidade acolhedora de alunos da América Latina, Europa, Ásia e muito além.',
      stat: 'Mais de 500 alunos satisfeitos ao redor do mundo',
    },
    learnMore: 'Saiba Mais',
    viewAllTestimonials: 'Ver todos os depoimentos',
    hero: {
      badge: 'PROFESSORES CERTIFICADOS CELTA E TESOL.',
      brand: 'FRANKLY TALKING',
      title: 'Fale Inglês com Confiança',
      subtitle: 'Aulas de inglês personalizadas para comunicação real, oportunidades internacionais e mais confiança para falar.',
      ctaPrimary: 'Teste seu Nível',
      ctaSecondary: 'Agende uma Aula',
    },
    why: {
      badge: 'Por Que Nos Escolher',
      title: 'Aprenda Inglês com [hl]Confiança[/hl]',
      body: 'Aprenda inglês com confiança, guiado por uma professora altamente qualificada e com ampla experiência internacional. Você será ensinado por uma instrutora nativa do português, com vasta experiência global no ensino da língua inglesa e certificação plena pela Universidade de Cambridge.',
      body2: 'Com mestrado e doutorado em andamento em Metodologia de Ensino de Língua Inglesa, nossa abordagem combina excelência acadêmica com habilidades práticas de comunicação para você alcançar fluência de forma mais rápida e eficaz.',
      closing: 'Comece hoje sua jornada rumo à fluência em inglês.',
      differentLabel: 'O que nos torna diferentes:',
    },
    howItWorks: {
      badge: 'Primeiros Passos',
      title: 'Como Funciona',
      subtitle: 'Uma jornada simples do primeiro passo até a comunicação com confiança.',
    },
    programsSection: {
      badge: 'Nossos Cursos',
      title: 'Programas Mais Procurados',
      subtitle: 'Opções de aprendizado flexíveis, pensadas para objetivos e progresso reais.',
      cta: 'Ver Todos os Cursos',
    },
    testimonialsSection: {
      badge: 'Depoimentos',
      title: 'O Que Nossos Alunos Dizem',
      subtitle: 'Histórias reais da nossa comunidade global de alunos.',
    },
    ctaSection: {
      title: 'Pronto Para Começar Sua [hl]Jornada no Inglês[/hl]?',
      body: 'Faça seu teste de nível gratuito ou agende uma aula experimental e descubra o caminho de aprendizado certo para seus objetivos.',
      primary: 'Teste seu Nível',
      secondary: 'Agende uma Aula',
    },
    featuresList: [
      { title: 'Experiência Internacional em Ensino', description: 'Experiência ensinando alunos de diferentes países, culturas e contextos de aprendizagem.' },
      { title: 'Especialização Certificada pela Cambridge', description: 'Certificação Cambridge com formação acadêmica avançada em Ensino de Língua Inglesa.' },
      { title: 'Mestrado e Especialização em Nível de Doutorado', description: 'Excelência acadêmica combinando mestrado com pesquisa de doutorado em andamento em Metodologia de Ensino de Língua Inglesa.' },
      { title: 'Explicações Claras para Falantes de Português', description: 'Uma professora nativa do português que entende suas dificuldades e explica o inglês com clareza.' },
      { title: 'Desenvolvimento da Fala', description: 'Aulas práticas voltadas a construir confiança em conversas reais.' },
    ],
    stepsList: [
      { title: 'Teste Seu Nível', description: 'Descubra seu nível atual através de uma avaliação rápida e prática.' },
      { title: 'Receba Seu Plano Recomendado', description: 'Sugerimos o pacote que melhor se encaixa no seu nível e nos seus objetivos.' },
      { title: 'Reserve e Comece a Aprender', description: 'Escolha seu pacote, agende suas aulas e comece a aprender com confiança.' },
    ],
    programsList: [
      { title: 'Inglês Geral', subtitle: 'Do Iniciante ao Avançado', description: 'Ganhe confiança para falar, ouvir, ler, escrever e dominar gramática e pronúncia.' },
      { title: 'Inglês para Negócios', subtitle: 'Comunicação Profissional', description: 'Comunique-se com mais profissionalismo e confiança em reuniões, e-mails, apresentações e entrevistas.' },
      { title: 'Inglês Acadêmico', subtitle: 'Inglês para Fins Acadêmicos', description: 'Prepare-se para redações, aulas, apresentações, anotações e sucesso acadêmico.' },
    ],
  },
  courses: {
    personalizedFor: 'Personalizado para',
    yourGoals: 'Seus Objetivos',
    availableNow: 'Disponível Agora',
    hero: {
      badge: 'Nossos Programas',
      title: 'Cursos Pensados Para [hl]Objetivos Reais[/hl]',
      body: 'Seja para melhorar seu inglês para o trabalho, estudos, viagens ou crescimento pessoal, nossos cursos são personalizados para ajudar você a avançar com confiança.',
    },
    ctaSection: {
      title: 'Não sabe qual curso é ideal para você?',
      body: 'Faça o teste de nível gratuito ou agende uma aula experimental e deixe a gente te ajudar a escolher o melhor caminho.',
      primary: 'Teste Seu Nível',
      secondary: 'Agende uma Aula',
    },
    coursesList: [
      {
        title: 'Inglês Geral para a Vida Real',
        subtitle: 'Do Iniciante ao Avançado',
        description: 'Fale inglês com confiança onde quer que a vida te leve. Nossas aulas de Inglês Geral te preparam para viagens, programas de intercâmbio, turismo, oportunidades de trabalho e para construir relacionamentos em contextos internacionais e multiculturais. Menos teoria, mais comunicação real. Aprenda o inglês que você realmente precisa para viver, se conectar e ter sucesso internacionalmente.',
        features: ['Resolva situações em aeroportos, hotéis e viagens com facilidade', 'Comunique-se profissionalmente no trabalho e em entrevistas', 'Conecte-se naturalmente em redes sociais e ambientes globais', 'Construa relacionamentos significativos com pessoas de diferentes culturas', 'Faça amigos e lide com conversas reais do dia a dia no exterior'],
        button: 'Agendar Aula Experimental',
      },
      {
        title: 'Inglês para Negócios',
        subtitle: 'Comunicação Profissional',
        description: 'Desenvolva as habilidades de linguagem e comunicação que você precisa para reuniões, apresentações, entrevistas, e-mails, negociações e interações no ambiente de trabalho internacional.',
        features: ['Redação de e-mails', 'Apresentações', 'Negociações', 'Preparação para entrevistas'],
        button: 'Agendar Aula Experimental',
      },
      {
        title: 'Inglês para Fins Acadêmicos',
        subtitle: 'Sucesso Acadêmico',
        description: 'Prepare-se para o sucesso acadêmico com aulas voltadas para redações, aulas expositivas, anotações, leitura acadêmica, apresentações e comunicação eficaz nos estudos em inglês.',
        features: ['Redação de ensaios', 'Técnicas de anotação', 'Habilidades de pesquisa', 'Vocabulário acadêmico'],
        button: 'Agendar Aula Experimental',
      },
      {
        title: 'Aulas de Conversação',
        subtitle: 'Fluência e Confiança',
        description: 'Pratique a fala real com confiança através de aulas dinâmicas baseadas em discussões, focadas em fluência, pronúncia, espontaneidade e comunicação natural.',
        features: ['Temas de discussão', 'Pronúncia', 'Fluidez natural', 'Construção de confiança'],
        button: 'Agendar Aula Experimental',
      },
      {
        title: 'Português Brasileiro',
        subtitle: 'Para Falantes Nativos de Inglês',
        description: 'Aprenda português brasileiro de forma natural, personalizada e que constrói confiança, com uma professora nativa que ajuda você a falar com clareza e naturalidade.',
        features: ['Professora nativa', 'Contexto cultural', 'Frases práticas', 'Ritmo personalizado'],
        button: 'Agendar Aula Experimental',
      },
    ],
  },
  pricing: {
    mostPopular: 'MAIS POPULAR',
    startingAt: 'A partir de',
    getStarted: 'Começar Agora',
    groupOption: 'Opção em grupo',
    groupOptionCaption: 'Ritmo compartilhado com uma rotina semanal estruturada.',
    privateOption: 'Opção individual',
    privateOptionCaption: 'Personalização máxima para um progresso acelerado.',
    focusLabel: 'Foco',
    focusValue: 'Desenvolvimento rápido da fala',
    rhythmLabel: 'Ritmo',
    rhythmValue: 'Prática semanal consistente',
    idealForLabel: 'Ideal para',
    idealForValue: 'Alunos com objetivos urgentes',
    intensiveMainImageAlt: 'Aluno em uma aula intensiva de inglês online',
    intensiveSecondaryImageAlt: 'Professora conduzindo uma aula de inglês ao vivo',
    recommendedWhen: 'Recomendado quando',
    recommendedWhenTitle: 'Você precisa de resultados em menos tempo',
    recommendedWhenBody: 'Ideal para mudança de país, objetivos de carreira, entrevistas, viagens ou preparação acadêmica.',
    specialOffersBadge: 'Ofertas Especiais',
    specialOffersTitle: 'Bônus e Promoções',
    specialOffersSubtitle: 'Valor extra para alunos comprometidos.',
    planLabels: {
      private: 'Atenção personalizada',
      pair: 'Aprendizado compartilhado',
      trio: 'Formato em pequena equipe',
      group: 'Melhor custo-benefício',
    },
    hero: {
      badge: 'Preços',
      title: 'Escolha Seu [hl]Plano[/hl]',
      body: 'Seja qual for a sua preferência, atenção personalizada ou aprender em grupo, temos a opção perfeita para você.',
    },
    ctaSection: {
      title: 'Não sabe qual pacote é ideal para você?',
      body: 'Faça o teste de nível gratuito e receba um plano recomendado com base no seu nível e objetivos.',
      primary: 'Teste Seu Nível',
      secondary: 'Agende uma Aula',
    },
    intensivePlan: {
      badge: 'Quer Resultados Mais Rápidos?',
      title: 'Plano Mensal Intensivo',
      subtitle: '3 aulas por semana',
      body: 'Perfeito para alunos que querem progresso real em menos tempo.',
      groupPriceTemplate: 'A partir de {{amount}}/mês (grupo)',
      privatePriceTemplate: 'A partir de {{amount}}/mês (particular)',
    },
    whyStudentsBadge: 'Por Que os Alunos Nos Escolhem',
    whyStudentsList: [
      { text: 'Inglês prático para situações reais no exterior' },
      { text: 'Grupos pequenos significam mais tempo de fala' },
      { text: 'Horários flexíveis, adaptados à sua rotina' },
      { text: 'Ensino premium com qualificações internacionais' },
    ],
    priceTemplate: '1 hora: {{amount}}',
    priceTemplatePerStudent: '1 hora: {{amount}} por aluno',
    lessonsTemplate: 'Pacote de 10 aulas: {{amount}} (economia de {{save}})',
    durationTemplate: 'Intensivo (1,5h): {{amount}}',
    packagesList: [
      { name: 'Aulas Particulares (1:1)', description: 'Para progresso rápido e total personalização', features: ['Atenção totalmente personalizada', 'Horário flexível', 'Google Meet incluso', 'Acompanhamento de progresso', 'Material personalizado'] },
      { name: 'Aulas em Dupla (2 alunos)', description: 'Aprenda com um amigo e mantenha a motivação', features: ['Aprenda com um amigo', 'Custo menor por aluno', 'Google Meet incluso', 'Mais tempo de fala', 'Aprendizado colaborativo'] },
      { name: 'Aulas em Trio (3 alunos)', description: 'Dinâmicas, interativas e acessíveis', features: ['Dinâmica de grupo pequeno', 'Mais interação', 'Google Meet incluso', 'Aprendizado entre colegas', 'Custo-benefício'] },
      { name: 'Grupo Pequeno (4–6 alunos)', description: 'Melhor custo-benefício e prática real de conversação', features: ['Melhor opção de custo-benefício', 'Prática real de conversação', 'Google Meet incluso', 'Ambiente de comunidade', 'Horário consistente'] },
    ],
    offersList: [
      { title: 'Oferta Especial', description: '20% de desconto para alunos de trio e grupo pequeno que adquirirem pacotes intensivos de 10 aulas.' },
      { title: 'Bônus de Indicação', description: 'Indique um amigo e receba 10% de desconto na renovação do seu próximo pacote após a matrícula dele.' },
    ],
  },
  about: {
    whatMakesUsDifferentBadge: 'Nossa Abordagem',
    whatMakesUsDifferentTitle: 'O Que Nos Torna Diferentes',
    whatMakesUsDifferentSubtitle: 'Nossa abordagem combina experiência com personalização.',
    coreValuesBadge: 'Princípios Norteadores',
    coreValuesTitle: 'Nossos Valores',
    coreValuesSubtitle: 'Os princípios que guiam tudo o que fazemos.',
    heroImageAlt: 'Aula de pronúncia em inglês',
    methodImageAlt: 'Alunos praticando conversação e interação',
    hero: {
      badge: 'Sobre Nós',
      title: 'Nossa História',
      body1: 'A Frankly Talking English nasceu de uma paixão pelo ensino e de um compromisso com a comunicação real. Com anos de experiência, metodologia certificada e uma abordagem personalizada, ajudamos alunos a falar com mais clareza, confiança e naturalidade.',
      body2: 'Acreditamos que todo aluno merece um ensino de inglês de alta qualidade, envolvente e prático. Nossa missão é derrubar barreiras linguísticas e ajudar as pessoas a se conectarem com o mundo através de uma comunicação confiante.',
      stat: 'Mais de 500 alunos de mais de 30 países',
    },
    methodology: {
      badge: 'Nossa Abordagem',
      title: 'Nossa Metodologia de Ensino',
      body: 'Nossas aulas são pensadas para equilibrar estrutura, comunicação e personalização. Acreditamos que os alunos aprendem melhor quando as aulas são práticas, envolventes e conectadas à vida real.',
    },
    ctaSection: {
      title: 'Pronto para aprender com [hl]confiança[/hl]?',
      body: 'Comece sua jornada com uma aula experimental ou descubra seu nível com nosso teste gratuito.',
      primary: 'Agendar Aula Experimental',
      secondary: 'Testar Seu Nível',
    },
    differentiatorsList: [
      { text: 'Trilhas de aprendizado personalizadas' },
      { text: 'Foco na comunicação real' },
      { text: 'Ensino certificado e experiente' },
      { text: 'Experiência de aprendizado flexível' },
      { text: 'Acompanhamento claro do progresso' },
      { text: 'Ambiente acolhedor que constrói confiança' },
    ],
    valuesList: [
      { title: 'Autenticidade', description: 'Conexões genuínas e feedback honesto' },
      { title: 'Empatia', description: 'Compreensão da sua jornada única de aprendizado' },
      { title: 'Confiança', description: 'Desenvolvendo sua capacidade de se comunicar livremente' },
      { title: 'Excelência', description: 'Altos padrões em tudo o que fazemos' },
      { title: 'Crescimento', description: 'Melhoria contínua e progresso constante' },
      { title: 'Comunicação', description: 'Troca clara, eficaz e significativa' },
    ],
    methodPointsList: [
      { text: 'Abordagem comunicativa focada no uso real' },
      { text: 'Aulas estruturadas com objetivos claros de aprendizagem' },
      { text: 'Feedback regular e acompanhamento do progresso' },
      { text: 'Conteúdo adaptado aos seus interesses e objetivos' },
    ],
  },
  header: {
    toggleMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    login: 'Entrar',
    signOut: 'Sair',
    adminPortal: 'Portal do Administrador',
    studentPortal: 'Portal do Aluno',
    myPortal: 'Meu Portal',
    selectLanguage: 'Selecionar idioma',
  },
  footer: {
    quickLinks: 'Links Rápidos',
    support: 'Suporte',
    contact: 'Contato',
    locationDefault: 'ONLINE NO MUNDO TODO - Aulas presenciais disponíveis mediante solicitação',
    descriptionDefault: 'Aulas online personalizadas, pensadas para você se comunicar com clareza, naturalidade e confiança.',
    studentAccess: 'Acesso do Aluno',
    copyright: 'Copyright {{year}} {{siteName}}. Todos os direitos reservados.',
    privacyPolicy: 'Política de Privacidade',
    termsOfService: 'Termos de Uso',
    taglineSuffix: 'Fale inglês com confiança.',
    developerCredit: 'Desenvolvido por Suddenly Creative and Technology',
  },
  contact: {
    hero: {
      badge: 'Fale Conosco',
      title: 'Vamos Conversar',
      body: 'Tem dúvidas ou quer ajuda para escolher o curso certo?\nEntre em contato e vamos te orientar.',
    },
    ctaCard: {
      title: 'Pronto Para Começar a Aprender?',
      body: 'Agende uma aula experimental e conheça nossa abordagem de ensino na prática.',
      button: 'Agendar Aula Experimental',
    },
    phoneText: 'Informe seu telefone ou WhatsApp no formulário e entraremos em contato por lá.',
    locationText: 'Aulas online em todo o mundo e presencial disponível',
    responseTime: 'Respondemos em até um dia útil',
    infoEmailTitle: 'Envie um E-mail',
    infoPhoneTitle: 'Telefone / WhatsApp',
    infoLocationTitle: 'Localização',
    infoResponseTimeTitle: 'Tempo de Resposta',
    nameLabel: 'Nome',
    namePlaceholder: 'Seu nome',
    emailLabel: 'E-mail',
    emailPlaceholder: 'seu@email.com',
    phoneLabel: 'Telefone / WhatsApp',
    phonePlaceholder: 'Seu telefone ou WhatsApp',
    inquiryForLabel: 'Esta solicitação é para',
    inquiryOptionMyself: 'Mim mesmo(a)',
    inquiryOptionAnotherPerson: 'Outra pessoa',
    inquiryOptionGroup: 'Um grupo de pessoas',
    inquiryOptionCompany: 'Uma empresa / equipe',
    ageLabelSelf: 'Sua idade',
    ageLabelStudent: 'Idade do aluno',
    agePlaceholder: 'Idade',
    groupSizeLabel: 'Tamanho aproximado do grupo',
    groupSizePlaceholder: 'Número de alunos',
    companyNameLabel: 'Nome da empresa',
    companyNamePlaceholder: 'Empresa / organização',
    ageRangeLabel: 'Faixa etária do grupo',
    ageRangePlaceholder: 'Exemplo: 14-17 ou adultos',
    teamSizeLabel: 'Tamanho da equipe',
    teamSizePlaceholder: 'Número de participantes',
    nativeLanguageLabelTeam: 'Principal idioma nativo da equipe',
    nativeLanguageLabelGroup: 'Principal idioma nativo do grupo',
    nativeLanguageLabelDefault: 'Idioma nativo',
    nativeLanguagePlaceholder: 'Português',
    countryLabelCompany: 'País / localização da empresa',
    countryLabelDefault: 'País',
    countryPlaceholder: 'Brasil',
    messageLabel: 'Mensagem',
    messagePlaceholderCompany: 'Conte-nos sobre os objetivos da equipe, o setor de atuação e o horário preferido.',
    messagePlaceholderGroup: 'Conte-nos sobre o grupo, os objetivos e o horário preferido.',
    messagePlaceholderDefault: 'Como podemos ajudar você?',
    sendButton: 'Enviar Mensagem',
    sending: 'Enviando...',
    errorFallback: 'Algo deu errado. Tente novamente.',
    successTitle: 'Mensagem Enviada!',
    successBody: 'Obrigado por entrar em contato. Retornaremos em até um dia útil.',
    consentPrefix: 'Ao enviar este formulário, você confirma que leu e concorda com nossa',
    consentAnd: 'e',
  },
  bookTrial: {
    durationBadge: '30-45 minutos',
    viaGoogleMeet: 'Via Google Meet',
    scheduleTitle: 'Agende sua Aula Experimental',
    scheduleBodyWithUrl: 'Clique no botão abaixo para ver os horários disponíveis e agendar sua aula experimental. As sessões duram aproximadamente 30-45 minutos, via Google Meet.',
    scheduleBodyWithoutUrl: 'Nosso link de agendamento está sendo finalizado. Use o botão abaixo para entrar em contato diretamente e organizaremos sua aula experimental pessoalmente.',
    openCalendarButton: 'Abrir Calendário de Agendamento',
    contactToScheduleButton: 'Entrar em Contato para Agendar',
    scheduleNoteWithUrl: 'Você será redirecionado(a) para nossa página de agendamento para escolher o melhor horário.',
    scheduleNoteWithoutUrl: 'Compartilhe seus dias e horários preferidos, e nossa equipe responderá com as melhores opções disponíveis.',
    hero: {
      badge: 'Comece Agora',
      title: 'Agende Sua [hl]Aula Experimental[/hl]',
      body: 'Comece com uma primeira sessão pensada para entender seu nível, seus objetivos e o melhor caminho para sua jornada de aprendizado.',
    },
    includesSection: {
      badge: 'Benefícios da Aula Experimental',
      title: 'O Que Está Incluso na Sua Aula Experimental',
      body: 'Uma introdução completa para você começar sua jornada no inglês com confiança.',
    },
    nextStepsSection: {
      badge: 'Próximos Passos',
      title: 'O Que Acontece Depois da Sua Aula Experimental',
    },
    bottomCta: {
      body: 'Ainda não está pronto para agendar? Faça primeiro nosso teste de nível gratuito.',
      button: 'Fazer Teste de Nível Gratuito',
    },
    includesList: [
      { title: 'Avaliação de Necessidades', description: 'Conversamos sobre seus objetivos, interesses e o que você quer alcançar com o inglês.' },
      { title: 'Avaliação de Nível', description: 'Uma conversa amigável para entender seu nível atual de inglês.' },
      { title: 'Plano Personalizado', description: 'Receba um caminho de aprendizado recomendado sob medida para suas necessidades.' },
      { title: 'Prévia do Estilo de Ensino', description: 'Conheça nossa abordagem de ensino envolvente e acolhedora.' },
    ],
    stepsList: [
      { title: 'Receba Sua Avaliação', description: 'Você receberá um retorno sobre seu nível atual e pontos a melhorar.' },
      { title: 'Receba Seu Plano Recomendado', description: 'Vamos sugerir o melhor curso e pacote com base nos seus objetivos.' },
      { title: 'Escolha Seu Pacote', description: 'Selecione o pacote de aulas que se encaixa na sua agenda e orçamento.' },
      { title: 'Comece Sua Jornada', description: 'Comece as aulas regulares e acompanhe seu progresso rumo à confiança no inglês.' },
    ],
  },
  auth: {
    login: {
      title: 'Bem-vindo(a) de Volta',
      subtitle: 'Entre para acessar seu portal de aprendizagem',
      emailLabel: 'E-mail',
      emailPlaceholder: 'seu@email.com',
      passwordLabel: 'Senha',
      passwordPlaceholder: 'Digite sua senha',
      submit: 'Entrar',
      submitting: 'Entrando...',
      newHere: 'Primeira vez aqui?',
      createAccount: 'Criar uma Conta',
      termsNotice: 'Ao entrar, você concorda com nossos Termos de Uso',
      suspendedMessage: 'Sua conta está suspensa. Entre em contato com o suporte para obter ajuda.',
      toastSuspendedTitle: 'Conta suspensa',
      toastWelcomeTitle: 'Bem-vindo(a) de volta!',
      toastWelcomeDescription: 'Conectado(a) como {{name}}',
      toastFailedTitle: 'Falha no login',
    },
    register: {
      title: 'Criar Conta',
      subtitle: 'Junte-se a nós e comece sua jornada no inglês',
      fullNameLabel: 'Nome Completo',
      fullNamePlaceholder: 'Seu nome completo',
      emailLabel: 'E-mail',
      emailPlaceholder: 'seu@email.com',
      phoneLabel: 'Telefone',
      phoneOptional: '(opcional)',
      phonePlaceholder: '+55 11 99999-9999',
      passwordLabel: 'Senha',
      passwordPlaceholder: 'Mínimo de 8 caracteres',
      confirmPasswordLabel: 'Confirmar Senha',
      confirmPasswordPlaceholder: 'Repita sua senha',
      submit: 'Criar Conta',
      submitting: 'Criando conta...',
      alreadyHaveAccount: 'Já tem uma conta?',
      signIn: 'Entrar',
      termsNotice: 'Ao criar uma conta, você concorda com nossos Termos de Uso',
      errorPasswordMismatch: 'As senhas não coincidem',
      errorPasswordTooShort: 'A senha deve ter no mínimo 8 caracteres',
      toastCreatedTitle: 'Conta criada!',
      toastCreatedDescription: 'Seu cadastro está aguardando aprovação.',
      toastFailedTitle: 'Falha no cadastro',
    },
  },
  levelTest: {
    hero: {
      badge: 'Avaliação de Nível',
      title: 'Descubra Seu [hl]Nível de Inglês[/hl]',
      body: 'Faça uma avaliação rápida para entender seu nível atual e receber um plano de aprendizado recomendado com base nos seus resultados.',
    },
    emailStep: {
      badge: 'Última Etapa',
      title: 'Veja Seu Resultado e Recomendação',
      body: 'Informe seu e-mail para desbloquear sua avaliação de nível, salvar seu resultado e receber o plano recomendado para seus objetivos no inglês.',
    },
    assessedHeading: 'O que será avaliado:',
    categoryGrammar: 'Gramática',
    categoryVocabulary: 'Vocabulário',
    categoryReadingComprehension: 'Compreensão de leitura',
    categoryPracticalCommunication: 'Comunicação prática',
    durationNote: 'Este teste leva aproximadamente de 5 a 10 minutos para ser concluído.',
    startButton: 'Iniciar Teste de Nível',
    emailLabel: 'E-mail',
    emailPlaceholder: 'seu@email.com',
    saving: 'Salvando seu resultado...',
    showResult: 'Ver Meu Resultado',
    reviewAnswers: 'Revisar minhas respostas',
    questionCounter: 'Pergunta {{current}} de {{total}}',
    previous: 'Anterior',
    next: 'Próxima',
    continueButton: 'Continuar',
    scoreLine: 'Pontuação: {{score}} de {{total}}',
    recommendedPlanLabel: 'Plano recomendado:',
    seePlanOptions: 'Ver minhas opções de plano',
    createAccountCta: 'Criar conta e começar',
    bookTrialCta: 'Agendar Aula Experimental',
    leadErrorFallback: 'Não foi possível salvar seu resultado agora. Tente novamente.',
    categoryBadge: {
      Grammar: 'Gramática',
      Vocabulary: 'Vocabulário',
      Reading: 'Leitura',
    },
    results: {
      beginner: {
        title: 'Você está no Nível Iniciante / Básico',
        description: 'Você está construindo sua base. Um plano de aprendizagem estruturado e de apoio ajudará você a crescer em confiança e consistência.',
        plan: 'Plano Inicial / Inglês Geral',
      },
      intermediate: {
        title: 'Você está no Nível Intermediário',
        description: 'Você já tem uma base sólida. Agora é o momento perfeito para melhorar a fluência, a precisão e a confiança na comunicação real.',
        plan: 'Plano Intermediário',
      },
      upperIntermediate: {
        title: 'Você está no Nível Intermediário Avançado',
        description: 'Você está pronto(a) para refinar sua comunicação, melhorar a precisão e usar o inglês com mais confiança em situações profissionais e do dia a dia.',
        plan: 'Plano Profissional / Progresso Avançado',
      },
      advanced: {
        title: 'Você está no Nível Avançado',
        description: 'Você já se comunica com confiança. Agora o foco é refinamento, precisão, sofisticação e fluência avançada.',
        plan: 'Plano Avançado / Intensivo',
      },
    },
  },
  legal: {
    badge: 'Jurídico',
    privacy: {
      title: 'Política de Privacidade',
      intro: 'Coletamos apenas as informações necessárias para responder a solicitações, gerenciar contas de alunos e oferecer as aulas com segurança e eficácia.',
      collectTitle: 'Informações que Coletamos',
      collectBody: 'Podemos coletar seu nome, e-mail, telefone, preferências de curso, mensagens do formulário de contato, solicitações de aula experimental, dados da conta e atividades de aprendizagem enviadas pelo portal do aluno.',
      useTitle: 'Como Usamos suas Informações',
      useBody: 'Usamos suas informações para responder solicitações, organizar aulas experimentais, recomendar cursos, gerenciar o acesso do aluno, comunicar sobre as aulas e melhorar a experiência de aprendizagem. Também podemos usar dados agregados do site para entender desempenho e eficácia de marketing.',
      sharingTitle: 'Compartilhamento de Dados',
      sharingBody: 'Não vendemos suas informações pessoais. Podemos compartilhar dados limitados com prestadores de serviço confiáveis, como plataformas de agendamento, análise, pagamento ou hospedagem, apenas quando necessário para operar a escola e prestar nossos serviços.',
      retentionTitle: 'Retenção e Segurança',
      retentionBody: 'Mantemos as informações apenas pelo tempo necessário para fins legítimos de negócio, educacionais, legais e de suporte. Utilizamos medidas administrativas e técnicas razoáveis para proteger os dados armazenados em nossos sistemas.',
      rightsTitle: 'Seus Direitos',
      rightsBody: 'Você pode solicitar acesso, correção ou exclusão das informações pessoais que armazenamos sobre você, sujeito a requisitos legais e operacionais. Para fazer uma solicitação, entre em contato conosco em',
      updatesTitle: 'Atualizações',
      updatesBody: 'Podemos atualizar esta política conforme a escola, os requisitos legais ou as ferramentas operacionais evoluem. O uso continuado do site após uma atualização significa que a política revisada se aplica.',
    },
    terms: {
      title: 'Termos de Uso',
      intro: 'Estes termos regem o uso do nosso site, do fluxo de agendamento de aulas experimentais, dos formulários de contato e do portal do aluno.',
      servicesTitle: 'Serviços',
      servicesBody: 'A Frankly Talking English oferece serviços de ensino de inglês, aulas experimentais, orientação de nivelamento e ferramentas de aprendizagem para alunos. Formatos de curso, horários, pacotes e disponibilidade podem mudar de acordo com a capacidade dos professores e as necessidades do programa.',
      bookingTitle: 'Agendamento e Comunicação',
      bookingBody: 'Solicitações de aula experimental, envios de contato e cadastros de alunos devem conter informações precisas. Podemos entrar em contato por e-mail ou outros canais aprovados para confirmar disponibilidade, nivelamento, agendamento e atualizações operacionais.',
      accountsTitle: 'Contas de Alunos',
      accountsBody: 'O acesso ao portal é pessoal e não deve ser compartilhado. Os usuários são responsáveis por manter a confidencialidade de suas credenciais de login e pelas atividades realizadas em sua conta.',
      paymentsTitle: 'Pagamentos e Agendamento',
      paymentsBody: 'Preços, formas de pagamento, condições dos pacotes e horários das aulas são confirmados durante o processo de matrícula. As condições de remarcação, cancelamento e reembolso podem variar conforme o pacote e serão comunicadas antes do início do serviço.',
      acceptableUseTitle: 'Uso Aceitável',
      acceptableUseBody: 'Os usuários não podem fazer mau uso do site, interferir na segurança da plataforma, tentar acesso não autorizado ou enviar conteúdo ilegal, abusivo ou enganoso por meio de qualquer formulário, aula, mensagem ou funcionalidade do portal.',
      contactTitle: 'Contato',
      contactBody: 'Se você tiver dúvidas sobre estes termos, entre em contato conosco em',
    },
  },
  testimonials: {
    readFullStory: 'Ler história completa',
    hero: {
      badge: 'Depoimentos',
      title: 'Histórias reais de alunos reais',
      body: 'Descubra como alunos de diferentes origens ganharam confiança no inglês com a abordagem de ensino acolhedora e personalizada da Cida.',
    },
    ctaSection: {
      title: 'Pronto Para Começar Sua Própria [hl]História de Sucesso[/hl]?',
      body: 'Comece com um teste de nível gratuito ou agende uma aula experimental e encontre o caminho certo para seus objetivos.',
      primary: 'Teste Seu Nível',
      secondary: 'Agende uma Aula',
    },
  },
  testimonialDetail: {
    backLink: 'Voltar para depoimentos',
    badge: 'História de Aluno',
    ctaTitle: 'Pronto para desenvolver sua confiança no inglês?',
    ctaBody: 'Comece sua jornada com aulas de inglês personalizadas, criadas de acordo com seus objetivos.',
    ctaPrimary: 'Comece sua jornada hoje',
    ctaSecondary: 'Agendar Aula Experimental',
  },
  faq: {
    hero: {
      badge: 'Suporte',
      title: 'Perguntas Frequentes',
      body: 'Encontre respostas para as dúvidas mais comuns sobre nossos cursos, agendamento e muito mais.',
    },
    ctaSection: {
      title: 'Ainda tem dúvidas?',
      body: 'Estamos aqui para ajudar. Entre em contato e responderemos a todas as suas perguntas.',
      primary: 'Fale Conosco',
      secondary: 'Agende uma Aula',
    },
    faqList: [
      { question: 'Como faço para agendar as aulas?', answer: 'Comece com o teste de nível gratuito ou uma aula experimental. Depois de entendermos seus objetivos e nível atual, confirmamos com você diretamente o melhor pacote e os horários disponíveis.' },
      { question: 'Vocês oferecem aulas online?', answer: 'Sim. As aulas online são realizadas ao vivo pelo Google Meet. Tudo o que você precisa é de uma conexão de internet estável e um computador ou tablet com câmera e microfone.' },
      { question: 'Vocês oferecem aulas presenciais?', answer: 'Sim, dependendo da disponibilidade e localização. Entre em contato para conversarmos sobre opções de aulas presenciais na sua região.' },
      { question: 'Como funciona o teste de nível?', answer: 'Nosso teste de nível é uma avaliação online rápida que analisa sua gramática, vocabulário, leitura e compreensão auditiva. Leva de 5 a 10 minutos e te dá uma visão prática do seu nível atual de inglês, ajudando a recomendar o melhor plano de aprendizado para você.' },
      { question: 'Como escolho o pacote certo?', answer: 'Recomendamos fazer primeiro o teste de nível gratuito, que vai nos ajudar a entender seu nível atual e sugerir um pacote adequado. Você também pode agendar uma aula experimental, onde conversamos sobre seus objetivos e recomendamos a melhor opção para você.' },
      { question: 'Posso remarcar aulas?', answer: 'Sim. As aulas podem ser remarcadas quando solicitado pela agenda de reservas com pelo menos 24 horas de antecedência. Se o aluno não avisar com 24 horas de antecedência, a aula perdida não terá direito a reembolso ou reposição.' },
      { question: 'Vocês ensinam crianças e adolescentes?', answer: 'Atualmente ensinamos alunos a partir de 16 anos. No momento, não oferecemos aulas para crianças mais novas.' },
      { question: 'Vocês oferecem Inglês para Negócios?', answer: 'Sim. Oferecemos aulas de Inglês para Negócios focadas em comunicação profissional real, incluindo reuniões, apresentações, e-mails, negociações e entrevistas. Essas aulas podem ser adaptadas à sua área ou profissão específica.' },
      { question: 'Quais são as qualificações dos professores?', answer: 'Nossa professora é certificada em CELTA (Cambridge), possui mestrado em TESOL e atualmente cursa doutorado com foco no ensino de inglês na era da inteligência artificial, combinando certificações reconhecidas internacionalmente com pesquisa de ponta em educação linguística.' },
      { question: 'Quanto tempo leva para ver resultados?', answer: 'O progresso varia de acordo com seu nível inicial, objetivos e o tempo que você dedica aos estudos. A maioria dos alunos percebe melhorias já nas primeiras semanas, especialmente em confiança e fluência.' },
      { question: 'Quais materiais vocês utilizam?', answer: 'Utilizamos uma combinação de materiais de curso de alta qualidade, recursos personalizados e conteúdo do mundo real, adaptados aos seus interesses e objetivos. Todo o material é disponibilizado pelo Google Classroom.' },
      { question: 'Como faço o pagamento das aulas?', answer: 'As formas de pagamento são confirmadas durante a matrícula, de acordo com o pacote escolhido e a localização. Entre em contato e informaremos os métodos de pagamento disponíveis e os próximos passos.' },
    ],
  },
};

export default ptBR;
